import React, { ReactNode } from 'react';

import InlinePromoBar from 'components/PlayerPromos/InlinePromoBar';
import { PromoData } from 'components/SaloonLobby/types';

import RibbonSlides from './RibbonSlides';

import styles from './PromoStrip.module.scss';

interface PromoStripProps {
  /** The monthly promo, when one is running. */
  promo?: PromoData | null;
  onClick?: () => void;
  /** Riding in the header band (wide screens): header-height, left-aligned, no flow margins. */
  inHeader?: boolean;
  /**
   * The streak banner (EN-11155), when the player has one. With a promo it is
   * the slot's second slide; alone it holds the slot. Absent, the slot is
   * exactly the promo ribbon it always was.
   */
  streak?: ReactNode;
  /** Reduce animations: the slides switch with a cut. */
  still?: boolean;
}

const PromoStrip: React.FC<PromoStripProps> = ({
  promo,
  inHeader = false,
  streak,
  still = false
}) => {
  const slides: { key: string; label: string; node: ReactNode }[] = [];
  if (promo) slides.push({ key: 'promo', label: 'Promotion', node: <InlinePromoBar /> });
  if (streak) {
    slides.push({
      key: 'streak',
      label: 'Your streak',
      node: <div className={styles.streakRibbon}>{streak}</div>
    });
  }
  if (!slides.length) return null;

  return (
    <div
      className={`${styles.configurablePromoSlot} ${
        inHeader ? styles.configurablePromoSlotHeader : ''
      }`}>
      <RibbonSlides slides={slides} direction={inHeader ? 'y' : 'x'} still={still} />
    </div>
  );
};

export default PromoStrip;
